import React from 'react';

export default function () {
    return (
        <div className="container text-center">
            <h1>Something seems to have gone wrong</h1>
            <hr />
            <p>
                Something went wrong trying to process your request. Please go back and try again or <a href='mailto:info@revelr.com'>contact us</a> if the problem persists.
            </p>
        </div>
    );
}



// WEBPACK FOOTER //
// ./app/assets/javascripts/components/errors/routeError.jsx